module.exports = __webpack_public_path__ + "static/img/200286.845d2c8f.png";